import React, { useState, useEffect } from 'react';
import logo from "../assets/logo1.png"; 
import logoDark from "../assets/logo7.png"; 
import ExactPhoneMockupInteractive from "./iphone"; 
import DashboardMockup from './dashboard';

const IParkingImageCentricUI = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const heroSlides = [
    {
      badge: "Орон сууцны хотхон, байгууллагын итгэлт түнш",
      title1: "99,900₮-р зогсоолоо",
      title2: "ухаалаг болгоорой",
      desc: "Үнэтэй камер, нэмэлт тоног төхөөрөмж шаардлагагүй. Ухаалаг аппликейшн ашиглан зогсоолын хаалтаа удирдах 100% найдвартай шийдэл.",
      buttonsType: "download", 
      imageUrl: "https://images.unsplash.com/photo-1506521781263-d8422e82f27a?q=80&w=1170&auto=format&fit=crop"
    },
    {
      badge: "Байгууллага & СӨХ",
      title1: "Сар бүрийн суурь",
      title2: "хураамж 0₮",
      desc: "Хяналтыг бүрэн дижиталчилж, төлбөрөө төлөөгүй хэрэглэгчийн эрхийг автоматаар хязгаарлах ухаалаг экосистем.",
      buttonsType: "download", 
      imageUrl: "https://plus.unsplash.com/premium_photo-1661962915138-c10a03d4ae28?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      badge: "Оршин суугчдад",
      title1: "Ухаалаг гар утас тань",
      title2: "зогсоолын түлхүүр",
      desc: "App Store болон Play Store-оос апп татаж аваад шууд ашиглана. Хаалт гацах, дугаар танихгүй хүлээлгэх асуудал бүрэн шийдэгдлээ.",
      buttonsType: "download", 
      imageUrl: "https://plus.unsplash.com/premium_photo-1661963457416-185db28e96c6?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    }
  ];

  return (
    <div style={{ fontFamily: 'Arial, Helvetica, sans-serif' }} className="tw-bg-white tw-text-slate-800 tw-min-h-screen selection:tw-bg-emerald-500 selection:tw-text-black tw-scroll-smooth tw-overflow-x-hidden">
      
      {/* --- Navigation --- */}
      <nav className={`tw-fixed tw-w-full tw-z-50 tw-top-0 tw-transition-all tw-duration-500 ${scrolled ? 'tw-bg-white/95 tw-backdrop-blur-xl tw-shadow-sm tw-border-b tw-border-slate-100 tw-py-3' : 'tw-bg-transparent tw-py-4 md:tw-py-6'}`}>
        <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 md:tw-px-12 tw-flex tw-justify-between tw-items-center">
          
          <div className="tw-flex tw-items-center tw-z-50 tw-cursor-pointer">
            <img 
              src={scrolled || isMenuOpen ? logoDark : logo} 
              alt="IParking Logo"
              className="tw-h-8 sm:tw-h-12 md:tw-h-14 lg:tw-h-16 tw-w-auto tw-object-contain tw-transition-transform hover:tw-scale-105 tw-duration-300 tw-mr-3" 
            />
          </div>
          
          <div className="tw-hidden lg:tw-flex tw-items-center tw-bg-black/20 tw-backdrop-blur-md tw-rounded-full tw-px-6 tw-py-2 tw-space-x-8 tw-border tw-border-white/10 tw-shadow-inner">
            {['СӨХ-д', 'Оршин суугч', 'Хэрхэн ажиллах', 'Үнэ'].map((item, idx) => (
              <a key={idx} href={['#admin', '#resident', '#workflow', '#pricing'][idx]} className={`tw-text-sm tw-font-bold tw-transition-colors ${scrolled ? 'tw-text-slate-700 hover:tw-emerald-500' : 'tw-text-slate-200 hover:tw-emerald-400'}`}>
                {item}
              </a>
            ))}
          </div>

       

          <button 
            className={`lg:tw-hidden tw-p-2 tw-z-50 tw-rounded-full tw-backdrop-blur-md tw-transition-colors ${scrolled || isMenuOpen ? 'tw-bg-slate-100 tw-text-slate-900' : 'tw-bg-white/20 tw-text-white'}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} /></svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:tw-hidden tw-absolute tw-top-0 tw-left-0 tw-w-full tw-bg-white/95 tw-backdrop-blur-2xl tw-border-b tw-border-slate-100 tw-transition-all tw-duration-500 tw-origin-top tw-shadow-2xl ${isMenuOpen ? 'tw-translate-y-0 tw-opacity-100' : 'tw--translate-y-full tw-opacity-0'}`}>
          <div className="tw-pt-24 tw-pb-8 tw-px-6 tw-flex tw-flex-col tw-space-y-2">
            {['СӨХ-д', 'Оршин суугч', 'Хэрхэн ажиллах', 'Үнэ'].map((item, i) => (
              <a key={i} href={['#admin', '#resident', '#workflow', '#pricing'][i]} className="tw-text-lg tw-font-bold tw-text-slate-800 tw-py-4 tw-border-b tw-border-slate-50 tw-flex tw-justify-between hover:tw-text-emerald-500" onClick={() => setIsMenuOpen(false)}>
                {item}
                <svg className="tw-w-5 tw-h-5 tw-text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
              </a>
            ))}
            <button  className="tw-w-full tw-mt-6 tw-bg-emerald-500 tw-text-black tw-font-bold tw-py-4 tw-rounded-2xl tw-shadow-[0_10px_20px_rgba(52,211,153,0.3)]">Холбогдох</button>
          </div>
        </div>
      </nav>

      {/* --- HERO IMAGE SLIDER --- */}
      <section className="tw-relative tw-bg-[#0a0f1c] tw-h-[100svh] tw-min-h-[600px] tw-overflow-hidden tw-flex tw-flex-col tw-items-center tw-justify-center">
        {heroSlides.map((slide, index) => (
          <div 
            key={`bg-${index}`}
            className={`tw-absolute tw-inset-0 tw-w-full tw-h-full tw-transition-opacity tw-duration-1000 tw-ease-in-out ${activeSlide === index ? 'tw-opacity-100 tw-scale-100' : 'tw-opacity-0 tw-scale-105'}`}
            style={{ 
              backgroundImage: `url(${slide.imageUrl})`, 
              backgroundPosition: 'center', 
              backgroundSize: 'cover',
              transitionProperty: 'opacity, transform'
            }}
          >
            <div className="tw-absolute tw-inset-0 tw-bg-[#050b14]/60 tw-bg-gradient-to-t tw-from-[#050b14]/95 tw-via-[#050b14]/50 tw-to-transparent"></div>
          </div>
        ))}

        <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 md:tw-px-12 tw-text-center tw-relative tw-z-10 tw-flex-1 tw-flex tw-flex-col tw-justify-center tw-h-full tw-pt-16 md:tw-pt-20">
          {heroSlides.map((slide, index) => (
            <div 
              key={index}
              className={`tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-transition-all tw-duration-1000 tw-ease-[cubic-bezier(0.16,1,0.3,1)] tw-px-4 sm:tw-px-6
                ${activeSlide === index ? 'tw-opacity-100 tw-translate-y-0 tw-z-20' : 'tw-opacity-0 tw-translate-y-12 tw-z-0 tw-pointer-events-none'}
              `}
            >
              <div className="tw-inline-flex tw-items-center tw-px-4 md:tw-px-5 tw-py-2 tw-rounded-full tw-bg-white/10 tw-border tw-border-emerald-500/30 tw-backdrop-blur-md tw-mb-6 md:tw-mb-8 shadow-sm">
                <span className="tw-w-2 md:tw-w-2.5 tw-h-2 md:tw-h-2.5 tw-bg-emerald-400 tw-rounded-full tw-animate-pulse tw-mr-3 tw-shadow-[0_0_10px_rgba(52,211,153,0.9)]"></span>
                <span className="tw-text-xs sm:tw-text-sm tw-font-bold tw-text-white tw-tracking-wide">{slide.badge}</span>
              </div>
              
              <h1 className="tw-text-2xl sm:tw-text-5xl md:tw-text-5xl lg:tw-text-[76px] tw-uppercase tw-font-bold tw-tracking-tight tw-leading-[1.1] tw-mb-6 md:tw-mb-8 tw-text-white tw-drop-shadow-lg">
                {slide.title1}<br />
                <span className="tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-emerald-300 tw-via-emerald-400 tw-to-green-500">
                  {slide.title2}
                </span>
              </h1>
              
              <p className="tw-text-sm sm:tw-text-base md:tw-text-xl tw-text-slate-200 tw-font-medium tw-max-w-2xl tw-mx-auto tw-mb-8 md:tw-mb-12 tw-leading-relaxed tw-drop-shadow-md">
                {slide.desc}
              </p>
              
              {slide.buttonsType === 'download' && (
                <div className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-center tw-items-center tw-gap-4 md:tw-gap-5 tw-w-full sm:tw-w-auto">
                  <a href="https://apps.apple.com/ph/app/iparking-mn/id6761326511" className="tw-w-full sm:tw-w-[210px] tw-flex tw-items-center tw-justify-center tw-bg-black/80 tw-backdrop-blur-md hover:tw-bg-black tw-border tw-border-emerald-500/40 tw-text-white tw-px-5 tw-py-3.5 tw-rounded-2xl tw-transition-all tw-duration-300 hover:tw-scale-105 hover:tw-shadow-[0_0_25px_rgba(52,211,153,0.3)] tw-group">
                    <svg className="tw-w-7 tw-h-7 sm:tw-w-8 sm:tw-h-8 tw-mr-3 tw-text-white group-hover:tw-text-emerald-400 tw-transition-colors" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.04 2.34-.85 3.73-.78 1.44.05 2.62.62 3.33 1.6-3.04 1.74-2.52 5.5.48 6.81-.7 1.77-1.57 3.56-2.62 4.54zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.3 2.4-2.03 4.36-3.74 4.25z" />
                    </svg>
                    <div className="tw-text-left">
                      <div className="tw-text-[10px] tw-font-medium tw-text-slate-400 tw-leading-tight tw-mb-0.5">App Store-оос</div>
                      <div className="tw-text-[15px] sm:tw-text-[16px] tw-font-bold tw-leading-tight tw-tracking-tight">Татах</div>
                    </div>
                  </a>
                  
                  <a href="https://play.google.com/store/apps/details?id=mn.iparking.app&pcampaignid=web_share" className="tw-w-full sm:tw-w-[210px] tw-flex tw-items-center tw-justify-center tw-bg-black/80 tw-backdrop-blur-md hover:tw-bg-black tw-border tw-border-emerald-500/40 tw-text-white tw-px-5 tw-py-3.5 tw-rounded-2xl tw-transition-all tw-duration-300 hover:tw-scale-105 hover:tw-shadow-[0_0_25px_rgba(52,211,153,0.3)] tw-group">
                    <svg className="tw-w-7 tw-h-7 sm:tw-w-8 sm:tw-h-8 tw-mr-3" viewBox="0 0 466 511.98">
                      <g>
                        <path fill="#EA4335" d="M199.9 237.8l-198.5 232.37c7.22,24.57 30.16,41.81 55.8,41.81 11.16,0 20.93,-2.79 29.3,-8.37l0 0 244.16 -139.46 -130.76 -126.35z"/>
                        <path fill="#FBBC04" d="M433.91 205.1l0 0 -104.65 -60 -111.61 110.22 113.01 108.83 104.64 -58.6c18.14,-9.77 30.7,-29.3 30.7,-50.23 -1.4,-20.93 -13.95,-40.46 -32.09,-50.22z"/>
                        <path fill="#34A853" d="M199.42 273.45l129.85 -128.35 -241.37 -136.73c-8.37,-5.58 -19.54,-8.37 -30.7,-8.37 -26.5,0 -50.22,18.14 -55.8,41.86 0,0 0,0 0,0l198.02 231.59z"/>
                        <path fill="#4285F4" d="M1.39 41.86c-1.39,4.18 -1.39,9.77 -1.39,15.34l0 397.64c0,5.57 0,9.76 1.4,15.34l216.27 -214.86 -216.28 -213.46z"/>
                      </g>
                    </svg>
                    <div className="tw-text-left">
                      <div className="tw-text-[10px] tw-font-medium tw-text-slate-400 tw-leading-tight tw-mb-0.5">Play Store-оос</div>
                      <div className="tw-text-[15px] sm:tw-text-[16px] tw-font-bold tw-leading-tight tw-tracking-tight">Татах</div>
                    </div>
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="tw-absolute tw-bottom-8 tw-left-1/2 tw--translate-x-1/2 tw-flex tw-space-x-2 md:tw-space-x-3 tw-z-30">
          {heroSlides.map((_, idx) => (
            <button 
              key={idx} 
              onClick={() => setActiveSlide(idx)}
              className={`tw-h-1.5 md:tw-h-2 tw-rounded-full tw-transition-all tw-duration-500 ${activeSlide === idx ? 'tw-w-8 md:tw-w-10 tw-bg-emerald-400 tw-shadow-[0_0_10px_rgba(52,211,153,0.8)]' : 'tw-w-2 md:tw-w-2.5 tw-bg-white/30 hover:tw-bg-white/60'}`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </section>

    {/* --- RESIDENT APP INFO SECTION --- */}
      <section id="resident" className="tw-py-20 md:tw-py-32 tw-bg-slate-50/30 tw-overflow-hidden tw-relative">
        
        {/* Background Decorative Elements */}
        <div className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-overflow-hidden tw-pointer-events-none tw-z-0">
          <div className="tw-absolute tw-top-[-10%] tw-right-[-5%] tw-w-[500px] tw-h-[500px] tw-bg-emerald-400/10 tw-rounded-full tw-blur-3xl"></div>
          <div className="tw-absolute tw-bottom-[-10%] tw-left-[-5%] tw-w-[400px] tw-h-[400px] tw-bg-blue-400/5 tw-rounded-full tw-blur-3xl"></div>
        </div>

        <div className="tw-container tw-mx-auto tw-px-6 md:tw-px-12 tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-gap-16 lg:tw-gap-24 tw-relative tw-z-10">
          
          <div className="tw-w-full lg:tw-w-1/2">
            <div className="tw-inline-flex tw-items-center tw-px-4 tw-py-1.5 tw-rounded-full tw-bg-emerald-50 tw-text-emerald-700 tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-mb-6 tw-border tw-border-emerald-200">
              Оршин суугчдад
            </div>
            <h2 className="tw-text-3xl md:tw-text-4xl lg:tw-text-4xl tw-font-bold tw-text-slate-900 tw-mb-6 tw-tracking-tight tw-leading-tight">
              Аппликейшн ашиглан зогсоолоо удирд
            </h2>
            <p className="tw-text-base md:tw-text-lg tw-text-slate-600 tw-mb-10 tw-leading-relaxed">
              Гар утсаа ашиглан зогсоолоо удирдах нь хялбар бөгөөд хамгийн амар шийдэл юм.
            </p>
            
            <div className="tw-space-y-8">
              {[
                { 
                  icon: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z", 
                  title: "Ганц товшилтоор хаалт нээнэ", 
                  desc: "Аппликейшнд нэг удаа бүртгүүлэн нэвтэрсэн байхад л 'Нээх' товчийг дараад шууд нэвтэрнэ. Маш хурдан бөгөөд хялбар." 
                },
                { 
                  icon: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z", 
                  title: "Зочны нэг удаагийн код", 
                  desc: "Зочин ирэх бүрд гадагш гарч хаалт нээх шаардлагагүй. Та гар утаснаасаа код илгээж, зочдоо төвөггүй нэвтрүүлээрэй." 
                },
                { 
                  icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z", 
                  title: "100% Баталгаат ажиллагаа", 
                  desc: "Машины дугаар танихгүй гацах, хаалт нээгдэхгүй хүлээлгэх зэрэг хуучны системд гардаг алдаанууд огт гарахгүй." 
                }
              ].map((item, idx) => (
                <div key={idx} className="tw-flex tw-items-start tw-group">
                  <div className="tw-w-14 tw-h-14 tw-bg-white tw-text-emerald-500 tw-border tw-border-slate-200 tw-rounded-2xl tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-mr-5 group-hover:tw-bg-emerald-500 group-hover:tw-text-white group-hover:tw-border-emerald-500 group-hover:tw-shadow-[0_0_15px_rgba(52,211,153,0.4)] tw-transition-all tw-duration-300">
                    <svg className="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={item.icon} /></svg>
                  </div>
                  <div>
                    <h4 className="tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-2">{item.title}</h4>
                    <p className="tw-text-slate-500 tw-text-sm md:tw-text-base tw-leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="tw-w-full lg:tw-w-1/2 tw-relative tw-flex tw-justify-center tw-mt-12 lg:tw-mt-0">
            
            {/* ШИНЭЧЛЭГДСЭН СУМ БОЛОН ТАЙЛБАР */}
            <div className="tw-absolute tw-top-[42%] sm:tw-top-[35%] md:tw-top-[20%] tw-left-[5px] sm:tw-left-[5%] md:tw-left-[-40px] lg:tw-left-[-80px] tw-flex tw-flex-col tw-items-start tw-z-40 tw-pointer-events-none tw-animate-[float_3s_ease-in-out_infinite] tw-scale-[0.80] sm:tw-scale-90 md:tw-scale-100 tw-origin-left">
              
              {/* Гоёмсог Tooltip */}
              <div className="tw-bg-gradient-to-r tw-from-emerald-400 tw-to-emerald-500 tw-text-white tw-text-[12px] md:tw-text-sm tw-font-bold tw-px-4 md:tw-px-5 tw-py-2.5 md:tw-py-3 tw-rounded-2xl tw-shadow-[0_15px_35px_rgba(16,185,129,0.4)] tw-border tw-border-emerald-300/50 tw-flex tw-items-center tw-relative">
                Апп-ыг дарж туршиж үзээрэй
              </div>
              
              {/* Утас руу чиглэсэн муруй сум */}
              <svg className="tw-w-14 tw-h-14 md:tw-w-20 md:tw-h-20 tw-text-emerald-500 tw-mt-1 tw-ml-6 md:tw-ml-16 tw-drop-shadow-md" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Гүйдэг тасархай шугам */}
                <path d="M20 10 Q 50 80 90 80" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeDasharray="8 8" fill="none" className="tw-animate-[dash_20s_linear_infinite]" />
                {/* Сумны үзүүр */}
                <path d="M75 65 L 95 80 L 75 95" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
              </svg>
            </div>

            {/* IPHONE MOCKUP */}
            <div className="tw-relative tw-z-20 tw-transition-transform tw-duration-700 hover:tw-scale-[1.02]">
              <ExactPhoneMockupInteractive/>
            </div>
            
            {/* АРД ТАЛЫН ГОЁМСОГ ГЭРЭЛТЭЛТҮҮД */}
            <div className="tw-absolute tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-w-[250px] tw-h-[250px] md:tw-w-[350px] md:tw-h-[350px] tw-bg-emerald-400 tw-rounded-full tw-opacity-20 tw-blur-[80px] tw-z-0 tw-pointer-events-none"></div>
            <div className="tw-absolute tw-bottom-10 tw-right-10 tw-w-[200px] tw-h-[200px] tw-bg-blue-400 tw-rounded-full tw-opacity-20 tw-blur-[60px] tw-z-0 tw-pointer-events-none"></div>
          </div>

        </div>
      </section>

      {/* Animation CSS for the floating arrow */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-12px) rotate(2deg); }
        }
        @keyframes dash {
          to { stroke-dashoffset: -1000; }
        }
      `}} />

      {/* --- WORKFLOW / ХЭРХЭН АЖИЛЛАДАГ ВЭ ХЭСЭГ (SIMPLE PREMIUM) --- */}
      <section id="workflow" className="tw-py-20 md:tw-py-32 tw-bg-white tw-border-t tw-border-slate-100">
        <div className="tw-container tw-mx-auto tw-px-6 md:tw-px-12 tw-max-w-6xl">
          
          <div className="tw-max-w-2xl tw-mb-16 md:tw-mb-24">
            <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-text-slate-900 tw-mb-4 md:tw-mb-6 tw-tracking-tight">
              VIP хэрэглэгч болох 4 алхам
            </h2>
            <p className="tw-text-base md:tw-text-lg tw-text-slate-500 tw-leading-relaxed">
              Оршин суугч та доорх энгийн алхмуудын дагуу бүртгэлээ үүсгэж, зогсоолоо ухаалгаар удирдах бүрэн эрхтэй болно.
            </p>
          </div>

          <div className="tw-relative">
            {/* Хэвтээ холбогч нарийн шугам (Зөвхөн Desktop дээр) */}
            <div className="tw-hidden md:tw-block tw-absolute tw-top-[24px] tw-left-[24px] tw-right-[24px] tw-h-[1px] tw-bg-slate-200 tw-z-0"></div>

            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-10 md:tw-gap-8 tw-relative tw-z-10">
              
              {/* Алхам 1 */}
              <div className="tw-flex tw-flex-row md:tw-flex-col tw-group tw-relative">
                {/* Босоо холбогч шугам (Зөвхөн Mobile дээр) */}
                <div className="md:tw-hidden tw-absolute tw-left-[23px] tw-top-[48px] tw-bottom-[-40px] tw-w-[1px] tw-bg-slate-200 tw-z-0"></div>

                <div className="tw-w-12 tw-h-12 tw-shrink-0 tw-rounded-full tw-bg-white tw-border tw-border-slate-300 tw-flex tw-items-center tw-justify-center tw-relative tw-z-10 tw-transition-colors group-hover:tw-border-slate-900 group-hover:tw-bg-slate-50">
                   <span className="tw-text-sm tw-font-bold tw-text-slate-900">01</span>
                </div>
                <div className="tw-ml-6 md:tw-ml-0 md:tw-mt-6 tw-pb-1">
                  <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-1 md:tw-mb-2">Код авах</h3>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-max-w-[250px]">
                    СӨХ эсвэл зогсоолын захиргаанд хандан өөрийн бүртгүүлэх нууц кодыг авна.
                  </p>
                </div>
              </div>

              {/* Алхам 2 */}
              <div className="tw-flex tw-flex-row md:tw-flex-col tw-group tw-relative">
                {/* Босоо холбогч шугам (Зөвхөн Mobile дээр) */}
                <div className="md:tw-hidden tw-absolute tw-left-[23px] tw-top-[48px] tw-bottom-[-40px] tw-w-[1px] tw-bg-slate-200 tw-z-0"></div>

                <div className="tw-w-12 tw-h-12 tw-shrink-0 tw-rounded-full tw-bg-white tw-border tw-border-slate-300 tw-flex tw-items-center tw-justify-center tw-relative tw-z-10 tw-transition-colors group-hover:tw-border-slate-900 group-hover:tw-bg-slate-50">
                   <span className="tw-text-sm tw-font-bold tw-text-slate-900">02</span>
                </div>
                <div className="tw-ml-6 md:tw-ml-0 md:tw-mt-6 tw-pb-1">
                  <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-1 md:tw-mb-2">Хүсэлт илгээх</h3>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-max-w-[250px]">
                    Аппликейшнээ татаж, тухайн кодоо оруулан автомашины мэдээллээ илгээнэ.
                  </p>
                </div>
              </div>

              {/* Алхам 3 */}
              <div className="tw-flex tw-flex-row md:tw-flex-col tw-group tw-relative">
                {/* Босоо холбогч шугам (Зөвхөн Mobile дээр) */}
                <div className="md:tw-hidden tw-absolute tw-left-[23px] tw-top-[48px] tw-bottom-[-40px] tw-w-[1px] tw-bg-slate-200 tw-z-0"></div>

                <div className="tw-w-12 tw-h-12 tw-shrink-0 tw-rounded-full tw-bg-white tw-border tw-border-slate-300 tw-flex tw-items-center tw-justify-center tw-relative tw-z-10 tw-transition-colors group-hover:tw-border-slate-900 group-hover:tw-bg-slate-50">
                   <span className="tw-text-sm tw-font-bold tw-text-slate-900">03</span>
                </div>
                <div className="tw-ml-6 md:tw-ml-0 md:tw-mt-6 tw-pb-1">
                  <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-1 md:tw-mb-2">Хүсэлтийг баталгаажуулах</h3>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-max-w-[250px]">
                    Зогсоолын удирдлага эсвэл СӨХ админ самбараас таны илгээсэн хүсэлтийг хянаж үзээд баталгаажуулна.
                  </p>
                </div>
              </div>

              {/* Алхам 4 - Зөөлөн онцлох (Premium highlight) */}
              <div className="tw-flex tw-flex-row md:tw-flex-col tw-group tw-relative">
                {/* 4 дэх алхамд доошоо заасан шугам хэрэггүй */}
                
                <div className="tw-w-12 tw-h-12 tw-shrink-0 tw-rounded-full tw-bg-emerald-500 tw-border-2 tw-border-white tw-ring-1 tw-ring-emerald-500 tw-flex tw-items-center tw-justify-center tw-relative tw-z-10 tw-shadow-[0_4px_15px_rgba(16,185,129,0.3)]">
                   <svg className="tw-w-5 tw-h-5 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"/>
                   </svg>
                </div>
                <div className="tw-ml-6 md:tw-ml-0 md:tw-mt-6 tw-pb-1">
                  <h3 className="tw-text-lg tw-font-bold tw-text-emerald-600 tw-mb-1 md:tw-mb-2">VIP эрх үүсэх</h3>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-max-w-[250px]">
                    Батлагдсанаар хаалт шууд нээх болон зочиндоо урилга илгээх бүрэн эрхтэй болно.
                  </p>
                </div>
              </div>

            </div>
          </div>
          
        </div>
      </section>

{/* --- ADVANCED ADMIN MANAGEMENT SECTION --- */}
      <section id="admin" className="tw-py-24 md:tw-py-32 tw-bg-white tw-border-t tw-border-slate-100">
        <div className="tw-container tw-mx-auto tw-px-6 md:tw-px-12">
          
          {/* Header */}
          <div className="tw-max-w-2xl tw-mb-20">
            <div className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-md tw-bg-slate-100 tw-text-slate-600 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-6">
              Админ удирдлагын систем
            </div>
            <h2 className="tw-text-3xl md:tw-text-5xl tw-font-bold tw-text-slate-900 tw-mb-6 tw-tracking-tight">
              Зогсоолын бүрэн менежмент
            </h2>
            <p className="tw-text-lg tw-text-slate-500 tw-leading-relaxed">
              Хотхон, албан байгууллагын зогсоолыг дижиталчлах нэгдсэн шийдэл. Бүх үйл явцыг нэг дороос хянах нь таны ажлыг 10 дахин хурдасгана.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8 tw-mb-24">
              {[
                { title: "Шуурхай бүртгэл", desc: "Хүсэлтийг бодит цагт хүлээн авч, ганц товшилтоор бүртгэл үүсгэнэ.", icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" },
                { title: "Эрх хязгаарлах", desc: "Төлбөр төлөөгүй хэрэглэгчийн нэвтрэх эрхийг системээс хязгаарлах боломжтой.", icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" },
                { title: "Нэгдсэн хяналт", desc: "Бүртгэл, ашиглалт, нэвтрэлтийн түүхийг нэг цонхоор бүрэн хянана.", icon: "M13 10V3L4 14h7v7l9-11h-7z" }
              ].map((card, i) => (
                <div key={i} className="tw-flex tw-flex-col tw-p-8 tw-rounded-2xl tw-border tw-border-slate-100 tw-transition-all tw-duration-300 hover:tw-border-slate-200 hover:tw-shadow-lg">
                  <div className="tw-w-10 tw-h-10 tw-text-emerald-500 tw-mb-6">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d={card.icon}/></svg>
                  </div>
                  <h3 className="tw-text-lg tw-font-bold tw-text-slate-900 tw-mb-3">{card.title}</h3>
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-flex-grow">{card.desc}</p>
                </div>
              ))}
          </div>

          {/* Dashboard Preview */}
          <div className="tw-text-center tw-mb-10">
            <h3 className="tw-text-xl tw-font-bold tw-text-slate-900">Хяналтын самбар </h3>
            <p className="tw-text-sm tw-text-slate-500 tw-mt-2">Зөвхөн бүртгэл батлах хэсгийг харуулсан болно.</p>
          </div>

          <div className="tw-w-full tw-flex tw-justify-center">
             <div className="tw-w-full tw-max-w-[1200px] tw-bg-white tw-border tw-border-slate-200 tw-rounded-2xl tw-shadow-[0_10px_40px_-10px_rgba(0,0,0,0.1)] tw-overflow-hidden">
                <div className="tw-bg-slate-50/50 tw-border-b tw-border-slate-100 tw-px-6 tw-py-4 tw-flex tw-items-center">
                    <div className="tw-flex tw-space-x-1.5 tw-mr-6">
                        <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-slate-300"></div>
                        <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-slate-300"></div>
                        <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-slate-300"></div>
                    </div>
                    <div className="tw-text-[10px] tw-text-slate-400 tw-font-mono tw-bg-white tw-px-3 tw-py-1 tw-rounded-md tw-border tw-border-slate-200"></div>
                </div>
                <div className="tw-p-6 tw-bg-slate-50/30">
                    <DashboardMockup />
                </div>
             </div>
          </div>
        </div>
      </section>



      {/* --- PRICING SECTION --- */}
      <section id="pricing" className="tw-py-20 md:tw-py-32 tw-bg-slate-50 tw-relative tw-overflow-hidden tw-border-t tw-border-slate-200">
        <div className="tw-container tw-mx-auto tw-px-6 md:tw-px-12 tw-relative tw-z-10">
          <div className="tw-text-center tw-mb-16 md:tw-mb-24">
            <h2 className="tw-text-3xl md:tw-text-5xl tw-font-bold tw-mb-6 tw-tracking-tight tw-text-slate-900">Үйлчилгээний тариф</h2>
            <p className="tw-text-slate-500 tw-text-lg md:tw-text-xl tw-max-w-xl tw-mx-auto">Хамгийн хямд бөгөөд ухаалаг үнийн саналыг бид танд санал болгож байна.</p>
          </div>
          
          <div className="tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-center lg:tw-items-stretch tw-gap-8 md:tw-gap-10 tw-max-w-5xl tw-mx-auto">
            
            {/* HOA Pricing Card */}
            <div className="tw-w-full lg:tw-w-1/2 tw-max-w-md tw-bg-white tw-rounded-[40px] tw-p-10 md:tw-p-12 tw-shadow-[0_10px_30px_rgba(0,0,0,0.05)] tw-border tw-border-slate-200 tw-transition-transform hover:tw--translate-y-2">
              <h3 className="tw-text-2xl tw-font-bold tw-text-slate-900 tw-mb-2">СӨХ / Байгууллагад</h3>
              <p className="tw-text-base tw-text-slate-500 tw-mb-8">Нэвтрүүлэлтийн зардал</p>
              <div className="tw-flex tw-items-baseline tw-mb-10 tw-pb-10 tw-border-b tw-border-slate-800">
                <span className="tw-text-6xl tw-font-bold tw-tracking-tighter tw-text-black">99,900₮</span>
                <span className="tw-text-slate-600 tw-ml-2">/ нэг удаа</span>
              </div>
              <ul className="tw-space-y-6 tw-text-slate-700 tw-font-medium tw-text-base">
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-6 tw-h-6 tw-text-emerald-500 tw-mr-4 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  Үнэтэй тоног төхөөрөмж шаардлагагүй
                </li>
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-6 tw-h-6 tw-text-emerald-500 tw-mr-4 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  Сарын суурь хураамж төлөхгүй
                </li>
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-6 tw-h-6 tw-text-emerald-500 tw-mr-4 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  Админ хяналтын систем үнэгүй
                </li>
              </ul>
              <button className="tw-w-full tw-mt-10 tw-bg-emerald-50 tw-border tw-border-emerald-200 tw-text-emerald-700 hover:tw-bg-emerald-100 tw-font-bold tw-py-4 tw-rounded-2xl tw-transition-colors">Холбогдох</button>
            </div>

            {/* Resident Pricing Card */}
            <div className="tw-w-full lg:tw-w-1/2 tw-max-w-md tw-bg-[#0a0f1c] tw-text-white tw-rounded-[40px] tw-p-10 md:tw-p-12 tw-shadow-[0_20px_40px_rgba(16,185,129,0.2)] tw-border tw-border-emerald-500/30 tw-relative tw-transform ">
              <div className="tw-absolute tw-top-0 tw-right-0 tw-bg-emerald-500 tw-text-White tw-text-xs tw-font-bold tw-px-4 tw-py-2 tw-rounded-bl-2xl tw-rounded-tr-[40px]">Зөвхөн апп хэрэглэгчид</div>
              <h3 className="tw-text-2xl tw-font-bold tw-mb-2">Апп ашиглалтын хураамж</h3>
              <p className="tw-text-base tw-text-slate-400 tw-mb-8">Гар утасны аппаараа хэрэглэгч сунгалтаа хийгээд явах боломжтой</p>
              <div className="tw-flex tw-items-baseline tw-mb-10 tw-pb-10 tw-border-b tw-border-slate-800">
                <span className="tw-text-6xl tw-font-bold tw-tracking-tighter tw-text-white">1,000₮</span>
                <span className="tw-text-slate-400 tw-ml-2">/ сард</span>
              </div>
              <ul className="tw-space-y-6 tw-text-slate-200 tw-font-medium tw-text-base">
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-6 tw-h-6 tw-text-emerald-400 tw-mr-4 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  Аппликейшнээр хаалт нээх бүрэн эрх
                </li>
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-6 tw-h-6 tw-text-emerald-400 tw-mr-4 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  Зочинд нэг удаагийн код илгээх
                </li>
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-6 tw-h-6 tw-text-emerald-400 tw-mr-4 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                  Олон зогсоол удирдах
                </li>
              </ul>
              <button className="tw-w-full tw-mt-10 tw-bg-emerald-500 tw-text-black hover:tw-bg-emerald-400 tw-font-bold tw-py-4 tw-rounded-2xl tw-transition-all tw-shadow-[0_0_15px_rgba(52,211,153,0.4)] hover:tw-shadow-[0_0_25px_rgba(52,211,153,0.6)] tw-active:tw-scale-95">Апп татах</button>
            </div>

          </div>
        </div>
      </section>

      {/* --- REALISTIC CORPORATE FOOTER --- */}
      <footer className="tw-bg-[#020617] tw-pt-20 tw-pb-10 tw-border-t tw-border-slate-800 tw-text-slate-400">
        <div className="tw-container tw-mx-auto tw-px-6 md:tw-px-12">
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-12 tw-mb-16">
            
            {/* Col 1: Brand Info */}
            <div className="tw-flex tw-flex-col tw-items-start">
              <img src={logo} alt="IParking" className="tw-h-12 md:tw-h-14 tw-mb-6 tw-opacity-90 hover:tw-opacity-100 tw-transition-opacity" />
              <p className="tw-text-sm tw-leading-relaxed tw-mb-6 tw-max-w-xs tw-text-slate-400">
                Орон сууцны хотхон, албан байгууллагуудад зориулсан зогсоолын ухаалаг, нэгдсэн экосистем. 100% найдвартай ажиллагаа.
              </p>
            </div>

            {/* Col 2: Contact Info */}
            <div>
              <h4 className="tw-text-white tw-font-bold tw-mb-6 tw-uppercase tw-tracking-wider tw-text-sm">Холбоо барих</h4>
              <ul className="tw-space-y-5">
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-5 tw-h-5 tw-mr-4 tw-text-emerald-500 tw-shrink-0 tw-mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  <div>
                    <div className="tw-text-xs tw-text-slate-500 tw-mb-1">Борлуулалт, хамтын ажиллагаа:</div>
                    <a href="tel:92920002" className="tw-text-white tw-font-bold hover:tw-text-emerald-400 tw-transition-colors tw-text-lg">9292-0002</a>
                  </div>
                </li>
                <li className="tw-flex tw-items-start">
                  <svg className="tw-w-5 tw-h-5 tw-mr-4 tw-text-emerald-500 tw-shrink-0 tw-mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 5.636A9 9 0 105.636 18.364m12.728-12.728A9 9 0 0118 11.5a1.5 1.5 0 01-1.5 1.5h-1a1.5 1.5 0 01-1.5-1.5V9.5a1.5 1.5 0 011.5-1.5h1a6.002 6.002 0 00-11 0h1a1.5 1.5 0 011.5 1.5v2a1.5 1.5 0 01-1.5 1.5h-1a1.5 1.5 0 01-1.5-1.5 9 9 0 0012.728 12.728" /></svg>
                  <div>
                    <div className="tw-text-xs tw-text-slate-500 tw-mb-1">Техникийн тусламж (24/7):</div>
                    <a href="tel:88449920" className="tw-text-white tw-font-bold hover:tw-text-emerald-400 tw-transition-colors tw-text-lg">8844-9920</a>
                  </div>
                </li>
                <li className="tw-flex tw-items-center tw-mt-2">
                  <svg className="tw-w-5 tw-h-5 tw-mr-4 tw-text-emerald-500 tw-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                  <a href="mailto:iparkingiparking@gmail.com" className="tw-font-medium hover:tw-text-emerald-400 tw-transition-colors">iparkingiparking@gmail.com</a>
                </li>
              </ul>
            </div>

            {/* Col 3: App Links */}
            <div>
              <h4 className="tw-text-white tw-font-bold tw-mb-6 tw-uppercase tw-tracking-wider tw-text-sm">Аппликейшн татах</h4>
              <div className="tw-flex tw-flex-col tw-space-y-3">
                <a href="https://apps.apple.com/ph/app/iparking-mn/id6761326511" className="tw-flex tw-items-center tw-bg-white/5 hover:tw-bg-white/10 tw-border tw-border-white/10 tw-rounded-2xl tw-p-3.5 tw-transition-colors tw-max-w-[220px] tw-group">
                  <svg className="tw-w-7 tw-h-7 tw-text-white group-hover:tw-text-emerald-400 tw-transition-colors" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.04 2.34-.85 3.73-.78 1.44.05 2.62.62 3.33 1.6-3.04 1.74-2.52 5.5.48 6.81-.7 1.77-1.57 3.56-2.62 4.54zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.3 2.4-2.03 4.36-3.74 4.25z" />
                  </svg>
                  <div className="tw-ml-3">
                    <div className="tw-text-[10px] tw-text-slate-400 tw-leading-tight">App Store-оос</div>
                    <div className="tw-text-sm tw-font-bold tw-text-white tw-leading-tight tw-mt-0.5">ТАТАХ</div>
                  </div>
                </a>
                <a href="https://play.google.com/store/apps/details?id=mn.iparking.app" className="tw-flex tw-items-center tw-bg-white/5 hover:tw-bg-white/10 tw-border tw-border-white/10 tw-rounded-2xl tw-p-3.5 tw-transition-colors tw-max-w-[220px] tw-group">
                  <svg className="tw-w-7 tw-h-7" viewBox="0 0 466 511.98">
                    <g>
                      <path fill="#EA4335" d="M199.9 237.8l-198.5 232.37c7.22,24.57 30.16,41.81 55.8,41.81 11.16,0 20.93,-2.79 29.3,-8.37l0 0 244.16 -139.46 -130.76 -126.35z"/>
                      <path fill="#FBBC04" d="M433.91 205.1l0 0 -104.65 -60 -111.61 110.22 113.01 108.83 104.64 -58.6c18.14,-9.77 30.7,-29.3 30.7,-50.23 -1.4,-20.93 -13.95,-40.46 -32.09,-50.22z"/>
                      <path fill="#34A853" d="M199.42 273.45l129.85 -128.35 -241.37 -136.73c-8.37,-5.58 -19.54,-8.37 -30.7,-8.37 -26.5,0 -50.22,18.14 -55.8,41.86 0,0 0,0 0,0l198.02 231.59z"/>
                      <path fill="#4285F4" d="M1.39 41.86c-1.39,4.18 -1.39,9.77 -1.39,15.34l0 397.64c0,5.57 0,9.76 1.4,15.34l216.27 -214.86 -216.28 -213.46z"/>
                    </g>
                  </svg>
                  <div className="tw-ml-3">
                    <div className="tw-text-[10px] tw-text-slate-400 tw-leading-tight">Play Store-оос</div>
                    <div className="tw-text-sm tw-font-bold tw-text-white tw-leading-tight tw-mt-0.5">ТАТАХ</div>
                  </div>
                </a>
              </div>
            </div>

          </div>
          
          {/* Bottom Copyright & Legal Links */}
          <div className="tw-pt-8 tw-border-t tw-border-white/10 tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-text-xs tw-text-slate-500">
            <p>© {new Date().getFullYear()} IParking ХХК. Бүх эрх хуулиар хамгаалагдсан.</p>
            <div className="tw-flex tw-space-x-6 tw-mt-4 md:tw-mt-0">
              <a href="#" className="hover:tw-text-white tw-transition-colors">Үйлчилгээний нөхцөл</a>
              <a href="#" className="hover:tw-text-white tw-transition-colors">Нууцлалын бодлого</a>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default IParkingImageCentricUI;